var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_vm._v("\n    页面正在加载中，请稍等...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }